import styled, { keyframes } from "styled-components";

const slideIn = keyframes`
  from{
    transform:translateX(300px)
  }
  to{
    transform:translateX(0)
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  background-color: ${props => props.theme.backgroundDark};
  animation: ${slideIn} 0.7s ease-in-out;

  .links {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 40px;

    p {
      color: ${props => props.theme.textLight};
      font-size: ${props => props.theme.p1r.fs};
      width: calc(100% - 24px);
      padding: 8px 16px;
      border-radius: ${props => props.theme.br.md};
      text-align: center;
      cursor: pointer;
      transition: background-color 0.15s ease;

      &:hover {
        background-color: ${props => props.theme.backgroundHover};
      }

      &:active {
        background-color: ${props => props.theme.primary};
      }
    }

    .break-line {
      opacity: 0.2;
      width: 85%;
      margin: auto;
      margin-bottom: 14px;
      margin-top: -4px;
      background-color: ${props => props.theme.textLight};
      height: 1.5px;
    }
    * {
      margin-bottom: 14px;
    }
  }
`;
